import { useEffect } from 'react';
import { useABTestContext } from '../ab-tests/context/useABTestContext';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import AnalyticsService from '../Services/AnalyticsService';
import { TRunningTests } from '../ab-tests/types/running-tests-config';

interface TIntentSpecificAbTestProps {
    experimentName: keyof TRunningTests;
    test_variant: string;
    fallback_variant: string;
    trackEvent?: string;
    fallbackErrorEvent?: string;
    mediumUpExperiment?: boolean;
}

export const useIntentExperimentEnabled = ({ experimentName, test_variant, fallback_variant, trackEvent, fallbackErrorEvent, mediumUpExperiment = true}: TIntentSpecificAbTestProps) => {
    const { variantPerTest: { [experimentName]: abTestVariant } } = useABTestContext();
    const isExperimentEnabled = abTestVariant === test_variant;
    const breakpoints = useBreakpoint();
    
    useEffect(() => {
        if (!abTestVariant || !trackEvent) {
            return;
        }
        AnalyticsService.track(trackEvent, {
            [experimentName]: abTestVariant
        });
    }, [abTestVariant, trackEvent]);
    
    useEffect(() => {
        if (!fallbackErrorEvent) {
            return;
        }
        if (mediumUpExperiment && breakpoints.mediumUp === false && abTestVariant !== fallback_variant) {
            AnalyticsService.track(fallbackErrorEvent, {
                [experimentName]: abTestVariant
            })
        }  
    }, [ breakpoints, abTestVariant, fallbackErrorEvent]);

    return isExperimentEnabled ;
};
